import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {TreeNode} from "primeng/api";
import {DomHandler} from "primeng/dom";
import {TreeTable, TreeTableService} from "primeng/treetable";
import {Table, TableService} from "primeng/table";
import {ObjectUtils} from "primeng/utils";
import {UserService} from "@app/core";
import {PrimeNgSupportService, TableApp, TreeViewType} from "@app/shared";
import {AbstractDataTableComponent} from "@app/shared/table/abstract-data-table/abstract-data-table.component";

export function treeTableFactory(treeTableComponent: TreeDataTableComponent): TreeTable {
  return treeTableComponent.treeTable;
}

@Component({
  selector: 'app-tree-data-table',
  templateUrl: './tree-data-table.component.html',
  styleUrls: ['./tree-data-table.component.css'],
  providers: [
    DomHandler,                                     // from new imports
    ObjectUtils,                                    // from new imports
    TableService,
    TreeTableService,                               // from old imports
    {
      provide: TreeTable,                           // providing table class
      useFactory: treeTableFactory,
      deps: [TreeDataTableComponent],               // new function depends on your wrapper
    },
    {
      provide: Table,// providing table class
    },
  ],
})
export class TreeDataTableComponent extends AbstractDataTableComponent implements OnInit, OnChanges {

  TableApp: typeof TableApp = TableApp;

  @Input() treeViewType: TreeViewType;
  @Input() flatValue: any[];

  _expandAllRows: boolean = false;
  @Input()
  set expandAllRows(val: boolean) {
    if (val != this._expandAllRows && this.value?.length > 0) {
      if (val && !this.allRowsExpanded) {
        this.onClickExpandOrCollapseAllRows();  // expand all
      } else if (!val && this.allRowsExpanded) {
        this.onClickExpandOrCollapseAllRows();  // collapse all
      } else {
        console.debug("tree-data-table expandAllRows: expandAllRows no change because value is empty or no change required.");
      }
    }
    this._expandAllRows = val;
  }

  get expandAllRows(): any {
    return this._expandAllRows;
  }

  @Output() onNodeSelect = new EventEmitter<any>();

  @ViewChild('treeTable', {static: true}) public treeTable: TreeTable;

  constructor(private cdr: ChangeDetectorRef, private user: UserService, public primeNgService: PrimeNgSupportService) {
    super();
  }

  ngOnInit(): void {
    this.setDefaultProperties();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  onNodeSelectEmit(event) {
    this.onNodeSelect.emit(event);
  }

  onClickExpandOrCollapseAllRows(): void {
    if (!this.allRowsExpanded) {
      this.user.expandTreeTableAndSaveToCache(this.treeTable);
    } else {
      this.user.collapseTreeTableAndSaveToCache(this.treeTable);
    }
    this.allRowsExpanded = !this.allRowsExpanded;
    this.handleReloadValue.emit(this.value);
  }

  onNodeExpandSaveStatus(treeNode: TreeNode): void {
    if (this.treeViewType) {
      this.user.saveExpandedTreeNodeToCache(treeNode);
    }
  }

  onHandleReloadValue(): void {
    this.handleReloadValue.emit(this.value);
  }

  onNodeCollapseSaveStatus(treeNode: TreeNode): void {
    if (this.treeViewType) {
      this.user.saveCollapsedTreeNodeToCache(treeNode);
    }
  }
}
